module.exports = __webpack_public_path__ + "img/bg_2_en.3d5b02f9.png";